import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Stack,
  Tabs,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useContext, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  StyledArrowButton,
  StyledTab,
} from "../../components/SmallComponents/AppComponents";
import Chart from "../../components/SmallComponents/Charts";
import { AppContext, twitterPostLink } from "../../utils";

const faqTextArray = [
  {
    head: "Original Posts",
    para: "Original posts receive a 5x point multiplier compared to comments whereas comments have the ability to earn bonus points by ratioing a post.",
  },
  {
    head: "Commenting",
    para: "Commenters who use the ticker $BGAI are also rewarded for the engagement they receive.",
  },
  {
    head: "Engagement",
    para: "You can earn points by engaging with any comment or original tweet that includes $BGAI in the post, you earn different points for liking, commenting, and reposting.",
  },
  {
    head: "XRationing",
    para: "If you ratio a post whether it is participating in $BGAI or not you will earn 50% of the points that the post has generated, this is to any original post on twitter.",
  },
];

const headingStyle = {
  fontFamily: "Saira Semi Condensed",
  fontWeight: 800,
  fontSize: { xs: "24px", sm: "30px" },
  letterSpacing: "1px",
  lineHeight: "36px",
  color: "#ffffff",
  textAlign: { xs: "center", md: "left" },
  textTransform: "uppercase",
};

export const dummyDays = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];
// export const dummyValues = [0, 10, 20, 30, 40, 50, 60, 70, 80, 20];

function calculatePointsPerDay(totalLike, numberOfDays) {
  const averageLikesPerDay = parseFloat(totalLike / numberOfDays)?.toFixed(0);
  const likesPerDayArray = Array(numberOfDays).fill(averageLikesPerDay);
  const remainder = totalLike % numberOfDays;

  for (let i = 0; i < remainder; i++) {
    likesPerDayArray[i]++;
  }

  return likesPerDayArray;
}

function EarnedPoints() {
  const { tweetHashTagsData } = useContext(AppContext);
  const matches = useMediaQuery("(max-width:750px)");
  const [expanded, setExpanded] = React.useState(false);
  const [tabValue, setTabValue] = useState(0);
  const handleChange = (panel, index) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleTabChange = (e, newVal) => {
    setTabValue(newVal);
  };

  return (
    <Box mt={6} mx={{ xs: 2, md: 4 }}>
      <Grid
        container
        spacing={4}
        flexDirection={{ xs: "column-reverse", md: "row" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: "start" },
            alignItems: { xs: "center", md: "start" },
            flexDirection: "column",
          }}
        >
          <Typography variant="h3" sx={headingStyle}>
            Points can be earned throught various different ways.
          </Typography>

          <Stack
            gap={3}
            mt={3}
            sx={{
              width: { xs: "100%", md: "80%" },
            }}
          >
            {faqTextArray.map(({ head, para }, i) => (
              <Accordion
                key={`panel${i}`}
                expanded={expanded === `panel${i}`}
                onChange={handleChange(`panel${i}`)}
                sx={{
                  background: "#D9D9D9",
                  border: "4px solid #807e7e",
                  borderRadius: "0px",
                  width: "100%",
                  m: "auto",
                  "&.MuiAccordion-root:before": {
                    height: "0px !important",
                  },
                  "&.MuiPaper-root": {
                    borderRadius: "0px !important",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMoreIcon
                      style={{
                        color: "#000000",
                        fontSize: "40px",
                      }}
                    />
                  }
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Box
                    fontSize={matches ? "19px" : "24px"}
                    fontWeight={700}
                    px={1}
                    py={1}
                    color="#111111"
                    fontFamily="Saira Semi Condensed"
                    letterSpacing={"1px"}
                    textTransform={"uppercase"}
                  >
                    {head}
                  </Box>
                </AccordionSummary>
                <AccordionDetails
                  sx={{
                    backgroundColor: "transparent",
                  }}
                >
                  <Box
                    pl={1}
                    py={1}
                    fontSize={{ xs: "14px", sm: "16px" }}
                    textAlign="left"
                    fontWeight="400"
                    lineHeight={"36px"}
                    color="#000000"
                    fontFamily="Montserrat"
                    textTransform={"uppercase"}
                  >
                    {para}
                  </Box>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>

          <Box
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: { xs: "center", md: "start" },
            }}
          >
            <StyledArrowButton
              href={twitterPostLink}
              target="_blank"
              width={"180px"}
            >
              Post Tweet
            </StyledArrowButton>
          </Box>
        </Grid>
        <Grid item xs={12} md={6} py={4}>
          <Stack height={"100%"} gap={{ xs: 2, md: 0 }}>
            <Tabs
              variant="scrollable"
              scrollButtons={false}
              value={tabValue}
              onChange={handleTabChange}
              sx={{
                width: "fit-content",
                px: 1,
                mt: { xs: 0, md: 2 },
              }}
              TabIndicatorProps={{
                style: { backgroundColor: "inherit" },
              }}
            >
              {["Original Tweet", "Likes", "Comments", "Engagement"].map(
                (info, i) => (
                  <StyledTab key={info}>{info}</StyledTab>
                )
              )}
            </Tabs>
            <Box height={{ xs: "300px", md: "80%" }}>
              <Chart
                lineColor="#8102FF"
                axisColorOne="rgba(0, 128, 246, 0) "
                axisColorTwo="#0f1b27"
                days={dummyDays}
                values={calculatePointsPerDay(
                  tabValue === 0
                    ? tweetHashTagsData?.postPoints
                    : tabValue === 1
                    ? tweetHashTagsData?.likesPoints
                    : tabValue === 2
                    ? tweetHashTagsData?.commentsPoints
                    : tweetHashTagsData?.viewsPoints,
                  7
                )}
                labelName={
                  tabValue === 0
                    ? "Original Tweet"
                    : tabValue === 1
                    ? "Likes"
                    : tabValue === 2
                    ? "Comments"
                    : "Engagement"
                }
              />
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}

export default EarnedPoints;
